import { render } from "./recent-actions.vue?vue&type=template&id=063e9d10&scoped=true"
import script from "./recent-actions.vue?vue&type=script&lang=js"
export * from "./recent-actions.vue?vue&type=script&lang=js"

import "./recent-actions.vue?vue&type=style&index=0&id=063e9d10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063e9d10"]])

export default __exports__